function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000px",
    height: "1000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#9c5ecb",
    d: "M 108.5,-0.5 C 369.167,-0.5 629.833,-0.5 890.5,-0.5C 939.983,8.14049 974.15,35.8072 993,82.5C 995.732,91.1643 997.899,99.831 999.5,108.5C 999.5,369.167 999.5,629.833 999.5,890.5C 990.86,939.983 963.193,974.15 916.5,993C 907.836,995.732 899.169,997.899 890.5,999.5C 629.833,999.5 369.167,999.5 108.5,999.5C 59.0172,990.86 24.8505,963.193 6,916.5C 3.17356,907.861 1.00689,899.194 -0.5,890.5C -0.5,629.833 -0.5,369.167 -0.5,108.5C 8.14049,59.0172 35.8072,24.8505 82.5,6C 91.1389,3.17356 99.8056,1.00689 108.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52134e",
    d: "M 114.5,31.5 C 369.5,31.3333 624.5,31.5 879.5,32C 918.163,35.6857 945.329,55.1857 961,90.5C 963.941,98.2638 965.941,106.264 967,114.5C 967.667,369.5 967.667,624.5 967,879.5C 960.5,931.333 931.333,960.5 879.5,967C 624.5,967.667 369.5,967.667 114.5,967C 79.2723,961.419 54.1056,942.585 39,910.5C 35.2471,900.488 32.9137,890.155 32,879.5C 31.3333,624.5 31.3333,369.5 32,114.5C 40.3459,67.6544 67.8459,39.9877 114.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#692d64",
    d: "M 88.5,132.5 C 354.333,131.334 620.333,131.167 886.5,132C 884.846,132.608 883.179,133.108 881.5,133.5C 617.334,132.5 353.001,132.167 88.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#874f82",
    d: "M 88.5,132.5 C 353.001,132.167 617.334,132.5 881.5,133.5C 693.358,159.568 505.358,186.568 317.5,214.5C 354.766,328.463 391.932,442.463 429,556.5C 430.446,560.814 431.446,565.147 432,569.5C 317.491,423.803 202.991,278.136 88.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#874f82",
    d: "M 716.5,604.5 C 685.165,604.333 653.832,604.5 622.5,605C 619.202,612.431 615.535,619.598 611.5,626.5C 652.595,524.971 694.262,423.637 736.5,322.5C 615.6,296.353 494.6,270.52 373.5,245C 553.465,219.374 733.465,194.041 913.5,169C 916.5,168.333 919.5,168.333 922.5,169C 837.167,313.667 751.833,458.333 666.5,603C 683.338,603.168 700.005,603.668 716.5,604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#874f82",
    d: "M 337.5,508.5 C 315.167,508.5 292.833,508.5 270.5,508.5C 206.027,399.203 141.861,289.87 78,180.5C 164.714,289.708 251.214,399.042 337.5,508.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#874f82",
    d: "M 385.5,284.5 C 474.618,306.696 563.618,329.363 652.5,352.5C 587.836,419.831 522.836,486.831 457.5,553.5C 433.091,463.94 409.091,374.273 385.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#885083",
    d: "M 560.5,661.5 C 560.5,642.5 560.5,623.5 560.5,604.5C 528.826,604.167 497.16,604.5 465.5,605.5C 451.993,660.699 438.993,716.032 426.5,771.5C 416.261,754.075 405.761,736.742 395,719.5C 394.503,721.81 394.337,724.143 394.5,726.5C 387.9,670.361 381.567,614.028 375.5,557.5C 395.159,581.167 414.492,605.167 433.5,629.5C 516.489,540.343 599.322,451.01 682,361.5C 642.343,461.818 601.843,561.818 560.5,661.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 270.5,508.5 C 292.833,508.5 315.167,508.5 337.5,508.5C 348.167,508.5 358.833,508.5 369.5,508.5C 371.501,524.842 373.501,541.175 375.5,557.5C 381.567,614.028 387.9,670.361 394.5,726.5C 395.162,730.466 395.495,734.466 395.5,738.5C 395.527,744.051 396.194,749.384 397.5,754.5C 399.932,772.432 401.932,790.432 403.5,808.5C 403.5,811.5 403.5,814.5 403.5,817.5C 372.167,817.5 340.833,817.5 309.5,817.5C 307.91,796.452 305.91,775.452 303.5,754.5C 269.498,754.333 235.498,754.5 201.5,755C 190.074,775.689 179.074,796.522 168.5,817.5C 135.816,818.159 103.483,817.493 71.5,815.5C 128.78,713.378 186.447,611.378 244.5,509.5C 253.141,508.502 261.808,508.169 270.5,508.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#53154f",
    d: "M 292.5,570.5 C 293.167,573.5 293.833,576.5 294.5,579.5C 295.93,613.234 298.264,646.9 301.5,680.5C 301.5,683.5 301.5,686.5 301.5,689.5C 278.5,689.5 255.5,689.5 232.5,689.5C 253.65,650.361 273.65,610.694 292.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a281a0",
    d: "M 292.5,570.5 C 292.56,569.957 292.893,569.624 293.5,569.5C 294.487,572.768 294.82,576.102 294.5,579.5C 293.833,576.5 293.167,573.5 292.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 560.5,661.5 C 559.49,687.829 558.99,714.162 559,740.5C 575.693,702.115 593.193,664.115 611.5,626.5C 615.535,619.598 619.202,612.431 622.5,605C 653.832,604.5 685.165,604.333 716.5,604.5C 700.013,675.45 683.679,746.45 667.5,817.5C 646.327,817.831 625.327,817.497 604.5,816.5C 617.079,758.856 630.579,701.522 645,644.5C 618.681,702.467 591.848,760.134 564.5,817.5C 546.833,817.5 529.167,817.5 511.5,817.5C 511.5,806.833 511.5,796.167 511.5,785.5C 511.321,740.483 511.987,695.483 513.5,650.5C 513.167,648.833 512.833,647.167 512.5,645.5C 501.292,703.132 488.625,760.466 474.5,817.5C 454.993,817.83 435.659,817.497 416.5,816.5C 419.579,801.44 422.912,786.44 426.5,771.5C 438.993,716.032 451.993,660.699 465.5,605.5C 497.16,604.5 528.826,604.167 560.5,604.5C 560.5,623.5 560.5,642.5 560.5,661.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfe",
    d: "M 794.5,604.5 C 818.809,602.293 842.475,605.127 865.5,613C 890.435,623.103 903.435,641.603 904.5,668.5C 883.833,668.5 863.167,668.5 842.5,668.5C 840.226,651.42 830.392,643.753 813,645.5C 805.087,644.603 797.92,646.436 791.5,651C 783.324,662.825 785.657,672.158 798.5,679C 813.683,684.728 829.016,690.061 844.5,695C 855.604,699.383 865.937,705.049 875.5,712C 893.22,728.375 898.387,748.208 891,771.5C 885.797,785.362 876.964,796.196 864.5,804C 848.591,812.635 831.591,817.635 813.5,819C 799.833,819.667 786.167,819.667 772.5,819C 751.406,817.53 732.74,810.197 716.5,797C 704.027,784.095 697.693,768.595 697.5,750.5C 718.169,750.333 738.836,750.5 759.5,751C 762.237,767.402 771.903,776.735 788.5,779C 798.9,780.469 808.9,779.135 818.5,775C 827.69,767.395 829.523,758.229 824,747.5C 819.654,742.826 814.487,739.326 808.5,737C 787.807,731.103 767.807,723.436 748.5,714C 725.678,700.847 717.178,681.347 723,655.5C 728.804,636.05 740.971,622.216 759.5,614C 770.91,609.4 782.576,606.233 794.5,604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#885083",
    d: "M 511.5,785.5 C 500.5,810.85 490,836.517 480,862.5C 471.224,847.942 462.724,833.275 454.5,818.5C 461.354,818.824 468.021,818.491 474.5,817.5C 488.625,760.466 501.292,703.132 512.5,645.5C 512.833,647.167 513.167,648.833 513.5,650.5C 511.987,695.483 511.321,740.483 511.5,785.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6b1c4",
    d: "M 301.5,680.5 C 302.479,683.625 302.813,686.958 302.5,690.5C 278.994,690.831 255.661,690.498 232.5,689.5C 255.5,689.5 278.5,689.5 301.5,689.5C 301.5,686.5 301.5,683.5 301.5,680.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2acc1",
    d: "M 395.5,738.5 C 396.957,743.598 397.624,748.931 397.5,754.5C 396.194,749.384 395.527,744.051 395.5,738.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfbdcd",
    d: "M 71.5,815.5 C 103.483,817.493 135.816,818.159 168.5,817.5C 135.669,818.664 102.669,818.831 69.5,818C 70.0659,817.005 70.7326,816.172 71.5,815.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1bfcf",
    d: "M 403.5,808.5 C 404.479,811.625 404.813,814.958 404.5,818.5C 372.662,818.832 340.996,818.498 309.5,817.5C 340.833,817.5 372.167,817.5 403.5,817.5C 403.5,814.5 403.5,811.5 403.5,808.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b79bb5",
    d: "M 416.5,816.5 C 435.659,817.497 454.993,817.83 474.5,817.5C 468.021,818.491 461.354,818.824 454.5,818.5C 441.483,818.832 428.483,818.499 415.5,817.5C 415.624,816.893 415.957,816.56 416.5,816.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b093ae",
    d: "M 604.5,816.5 C 625.327,817.497 646.327,817.831 667.5,817.5C 646.33,818.828 624.996,818.828 603.5,817.5C 603.624,816.893 603.957,816.56 604.5,816.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d5a89",
    d: "M 511.5,817.5 C 529.167,817.5 546.833,817.5 564.5,817.5C 556.343,818.329 548.01,818.829 539.5,819C 532.126,831.583 524.626,844.083 517,856.5C 521.211,844.053 526.044,831.72 531.5,819.5C 524.679,818.833 518.012,818.167 511.5,817.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAms);
export default __webpack_public_path__ + "static/media/icon-AMS.bb50f00e100fc46556c63b6932d16c58.svg";
export { ForwardRef as ReactComponent };